import { TIFormatPrefix } from '../../../../../../store/admin/roundFormats/store';
import { IResult, TFieldSuffix } from '../../../../../../store/admin/roundResults/store';
import { IHoleResult } from '../../../../../../store/admin/holeResults/store';
import { ScoreType } from '../../../../../../store/admin/eventFormats/store';

import { capitalizeFirstLetter } from '../../../../../../contrib/utils';

type TGetResultFieldName = (
  prefix: TIFormatPrefix,
  scoreType: ScoreType | null,
  field: TFieldSuffix,
  adjusted?: boolean,
  formatIsStableford?: boolean
) => keyof IResult;

export const getResultFieldName: TGetResultFieldName = (
  prefix,
  scoreType,
  field,
  adjusted,
  formatIsStableford
) => {
  return `${prefix}${adjusted && scoreType && ScoreType[scoreType] === 'NET' ? 'Adjusted' : ''}${
    scoreType ? capitalizeFirstLetter(ScoreType[scoreType].toLowerCase()) : ''
  }${formatIsStableford ? 'Stableford' : ''}${field}` as keyof (IResult | IHoleResult);
};
